import { defineStore } from "pinia";
import { ref } from "vue";

export const useCompanyId = defineStore("companyId", () => {
  const companyId = ref("");

  const setCompanyId = ({
    companyId: paramCompanyId,
  }: {
    companyId: string;
  }) => {
    companyId.value = paramCompanyId;
  };

  return {
    companyId,
    setCompanyId,
  };
});
